import { render, staticRenderFns } from "./AddUpdateResCategories.vue?vue&type=template&id=06eedc9e&scoped=true&"
import script from "./AddUpdateResCategories.vue?vue&type=script&lang=js&"
export * from "./AddUpdateResCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eedc9e",
  null
  
)

export default component.exports